//@ts-nocheck
import React, { useCallback, useState, useRef } from "react";
import useStateRef from "hooks/useStateRef";
import styles from "./TemplateManagerImageRollField.module.scss";
import { useEffect } from "react";
import dragIcon from "assets/images/drag-icon.svg";
import paginate from "utils/paginate";
import { useSingleton } from "hooks/useSingleton";
import TemplateManagerFieldAction from "../../TemplateManagerFieldAction/TemplateManagerFieldAction";
import TableField from "../../../FieldTypes/TableField/TableField";

/**
 * Table Field Type
 * @param {Object} props for the component as follows
 * @param {Object} color configuration data
 * @param {FieldInstance} initialFieldInstance for the field type
 * @param {FieldTemplate} fieldTemplate for the fieldInstance of this field type
 * @param {Object} updateObj from the realtime subs
 * @param {Boolean} online users' network status
 * @param {User} userDoc for the current user
 */
function TemplateManagerImageRollField(props) {
	const { color, initialFieldInstance, fieldTemplate, isExpanded, online, userDoc } = props;

	const tableRef = useRef(null);

	const [tableInstance, setTableInstance] = useStateRef(initialFieldInstance);
	const [loaded, setLoaded] = useState(true);
	const [fieldInstance, setFieldInstance] = useState(null);
	const [rowsData, setRowsData] = useState([]);
	const [headerMap, setHeaderMap] = useState(buildHeaderMap());
	const [rowsHtml, setRowsHtml] = useState([]);
	const [expanded, setExpanded] = useState(isExpanded);
	const [pageIndex, setPageIndex] = useState(1);
	const [checkedRows, setCheckedRows] = useStateRef([]);

	const grid = 8;
	const pageSize = 100;

	const { mode } = useSingleton();

	// put table data in the dom when its loaded
	useEffect(() => {
		if (loaded) {
			setRowsHtml(buildRows());
			setHeaderMap(buildHeaderMap());
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fieldTemplate, loaded]);

	/**
	 * this is specifically for when you need a TM field action or deve only field action, to have a callback
	 * but it doesnt do anything.
	 */
	function fakeCallback() {}

	/**
	 * setup the rows html.
	 * @returns html
	 */
	function buildRows() {
		const final = [];
		const finalRowsData = [];
		const tableMap = {};
		const tableDataMap = {};
		// These are supposed to come in already in order from either get or create
		for (let i = 0; i < fieldTemplate.tableFields.items.length; i++) {
			const tableField = fieldTemplate.tableFields.items[i];

			const html = (
				<td className={styles.cell} style={{ borderBottom: `1px solid ${color.border.primary}`, borderRight: `1px solid ${color.border.primary}` }}>
					<TemplateManagerFieldAction
						fieldInstance={{ value: "" }}
						fieldTemplate={tableField}
						updateObj={{}}
						fromTable={true}
						setExpandedField={fakeCallback}
						onSubmitCb={fakeCallback}
						setDeleteReset={fakeCallback}
						deleteReset={fakeCallback}
						online={online}
						userDoc={userDoc}
						parseAltInstanceToAwsThingy={fakeCallback}
						formInstance={{}}
					/>
				</td>
			);
			// Need to handle linked fields as well here

			// this is so we can easily reorder the rows, and have the data in an ordered rows
			// format
			tableMap[tableField.id] = html;
			tableDataMap[tableField.id] = tableField;
		}

		// now need to build the rows
		// going to use rowOrder as the rowId for now..
		const rowOrder = fieldTemplate.rowOrder;
		// const rowOrderArray = rowOrder.split(",");
		const row = [];
		const theRowsData = [];
		let rowId = rowOrder;
		for (let f = 0; f < rowOrder.length; f++) {
			const orderedId = rowOrder[f];
			const fieldHtml = tableMap[orderedId];
			const fieldData = tableDataMap[orderedId];
			row.push(fieldHtml);
			theRowsData.push(fieldData);
			// if(f === 0) {
			//     // first field in row's id is going to be added for the key of the row component
			//     rowId = rowId + orderedId;
			// }
		}

		const rowHtml = createRow(row, rowId);
		finalRowsData.push(theRowsData);
		final.push(rowHtml);

		setRowsData(finalRowsData);
		return final;
	}

	/**
	 * Setup the row data for a row.
	 * @param {HTML} fieldsHtml for the fields in the row.
	 * @param {String} rowKey csv of all the ids of fieldInstances in the row
	 * @returns object with rowkey key, and row containing the html.
	 */
	function createRow(fieldsHtml, rowKey) {
		const rowData = {
			key: rowKey,
			row: fieldsHtml,
		};

		return rowData;
	}

	/**
	 * Setup the html to be used in the DOM for a row in a table.
	 * @param {HTML} fieldsHtml for the fields in the row
	 * @param {integer} i index of the row
	 * @returns html
	 */
	function renderRow(fieldsHtml, i) {
		const rowKey = fieldsHtml.key;
		const rowChecked = checkedRows.includes(rowKey);
		const rowHtml = (
			<tr id={rowKey}>
				<td
					className={styles.options_cell}
					style={{ borderBottom: `1px solid ${color.border.primary}`, borderRight: expanded ? `1px solid ${color.border.primary}` : "none" }}>
					<div className={styles.options_cell_wrapper}>
						<input
							type="checkbox"
							id={rowKey}
							name={rowKey}
							value={rowKey}
							checked={rowChecked}
							onChange={fakeCallback}
							className={styles.checkbox}
						/>

						<div className={styles.drag_btn}>
							<img alt="drag me" className={styles.dragIconImg} src={dragIcon} />
						</div>
					</div>
				</td>
				{fieldsHtml.row}
			</tr>
		);

		return rowHtml;
	}

	//This needs to happen in the beginning at the moment, so uses the table fields form the template
	// to build out the headers
	/**
	 * builds the header map object
	 * @returns map of the header
	 */
	function buildHeaderMap() {
		const finalMap = {};
		for (let i = 0; i < fieldTemplate.tableFields.items.length; i++) {
			const tableFieldTemplate = fieldTemplate.tableFields.items[i];
			// final.push(html);
			finalMap[tableFieldTemplate.id] = tableFieldTemplate;
		}

		return finalMap;
	}

	/**
	 * build the header html for the table in the DOM
	 */
	const buildHeaders = useCallback(
		function () {
			const final = [];

			for (let i = 0; i < fieldTemplate.rowOrder.length; i++) {
				const tableFieldTemplateId = fieldTemplate.rowOrder[i];
				// const tableFieldTemplateId = tableFieldTemplate.id;
				const template = headerMap[tableFieldTemplateId];
				const html = (
					<th
						key={tableFieldTemplateId}
						index={i}
						className={styles.header}
						onClick={fakeCallback}
						style={{
							borderRight: expanded ? `1px solid ${color.border.primary}` : "none",
						}}>
						<div
							className={styles.headerTextWrapper}
							onClick={(e) => {
								const header = e.target;
								if (header.style.webkitLineClamp === "1") {
									header.style.webkitLineClamp = "unset";
								} else {
									header.style.webkitLineClamp = "1";
								}
							}}>
							{template.header}
						</div>
					</th>
				);
				final.push(html);
			}

			const bufferCell = (
				<th
					key={"buffer-header"}
					className={styles.buffer}
					style={{
						borderRight: expanded ? `1px solid ${color.border.primary}` : "none",
					}}></th>
			);

			final.unshift(bufferCell);

			return final;
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},
		[rowsData],
	);

	return (
		<div
			style={{
				backgroundColor: expanded ? color.background.primary : color.background.secondary,
			}}
			className={expanded ? `${styles.wrapper} ${styles.wrapperExpanded}` : styles.wrapper}>
			<div className={styles.tableTopBar} ref={tableRef}>
				<div
					style={{
						color: expanded ? color.text.primary : color.text.secondary,
						borderBottom: expanded ? `1px solid ${color.border.primary}` : "none",
					}}
					className={expanded ? `${styles.table_headerExpand}` : `${styles.table_header}`}>
					Table - {fieldTemplate.header} - Edit to view
					{/* {userDoc?.isDeveloper ? <Button colorPalette={color} onClick={copyId} className={styles.copyBtn}><Svg icon="CLIPBOARD" /></Button> : null} */}
				</div>
				<div
					style={{ borderBottom: expanded ? `1px solid ${color.border.secondary}` : "none" }}
					className={expanded ? styles.header_infoExpanded : styles.headerInfo}>
					<div className={expanded ? styles.tableHeader_buttons : styles.closedBtns}></div>
				</div>
			</div>
			<>
				{expanded ? (
					<>
						<div
							style={{
								color: color.text.secondary,
							}}
							className={styles.pagesAndRow}>
							<div className={styles.pages}>{rowsHtml.length / pageSize < 1 ? 1 : rowsHtml.length / pageSize} Page(s)</div>
							<div className={styles.rowsExpand}>{rowsHtml.length} Row(s)</div>
						</div>
					</>
				) : null}

				<div className={styles.tableWrapper}>
					<table
						style={{
							border: `1px solid ${color.border.primary}`,
							display: expanded ? "table" : "none",
						}}
						className={expanded ? `${styles.table} ${styles.tableExpanded}` : styles.table}>
						<thead>
							<tr
								style={{
									borderBottom: `1px solid ${color.border.primary}`,
									color: color.text.primary,
								}}
								className={styles.rowHeader}
								key={"headers"}>
								{buildHeaders()}
							</tr>
						</thead>
						<tbody className={expanded ? styles.visibleBody : styles.hiddenBody}>
							{/* HERE IS WHERE THE ROW HTML IS BEING PAGINATED AND ADDED TO THE HTML */}
							{paginate({ items: rowsHtml, pageIndex, pageSize }).map((row, index) => renderRow(row, index))}
						</tbody>
					</table>
				</div>
			</>
		</div>
	);
}

export default TemplateManagerImageRollField;
